import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-score-plan-component',
  templateUrl: './score-plan-component.component.html',
  styles: []
})
export class ScorePlanComponentComponent implements OnInit {
  @Input()planDynamicTableObjEnt;
  //获取config中的字段
  getConfigAttr(config,attr){
    return JSON.parse(config)[attr];
  }
  //评分细则
  public gradRulesVisible:any = false;
  gradRulesOk(){
    this.gradRulesVisible = false;
  }
  public gradRuleList:any;
  showRuleList(item){
    this.gradRulesVisible = true;
    if(JSON.parse(item.config).rules){
      this.gradRuleList = JSON.parse(item.config).rules;
    }
  }
  constructor() { }
  public planDynamicTableObj:any;
  ngOnInit() {
    this.planDynamicTableObj = JSON.parse(JSON.stringify(this.planDynamicTableObjEnt));
    this.planDynamicTableObj.dynamicFields.forEach((data) =>{
      if (data.config && JSON.parse(data.config).rules) {
        data.rules = JSON.parse(data.config).rules;
      }
    });
    this.expand();
  }


  public allExpand:boolean = false;
//  表格全部展开
  expand(){
    this.planDynamicTableObj.dynamicFieldGroups.forEach((item) => {
      item.expand = true;
    });
    this.allExpand = true;
  }

//  表格全部收起
  packUp(){
    this.planDynamicTableObj.dynamicFieldGroups.forEach((item) => {
      item.expand = false;
    });
    this.allExpand = false;
  }

}
